import Button from '../../../components/CustomButtons/ButtonTS';
import CheckBox from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlankOutlined'
import React from 'react';
import { INode } from '../../helpers/interfaces';
import Tooltip from "@material-ui/core/Tooltip";

interface IDeActivateIconProps {
	show: boolean;
	node: INode;
	showDeActivateCard(node: INode): void;
}

export const DeActivateIcon = (props: IDeActivateIconProps) => {
	const { show, node, showDeActivateCard } = props;

	if (!show) {
		return null;
	}

	return (
        <Tooltip title={node.active ? "Deactivate" : "Activate"}>
            <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
					onClick={() => showDeActivateCard(node)}
                    data-testid='deActivateIcon'
                >
                    {node.active ?
                        <CheckBox />
                    :
                        <CheckBoxOutlineBlank />
                    }
                </Button>
            </div>
        </Tooltip>
	);
};

export default DeActivateIcon;
